import notification from 'app/config/notification';
import { validateDocumentsDescription } from '../functions';
import { SERVICES_CODES } from '../../../config/services';
import companyEndpoints from '../../../api/services/companyEndpoints';

export const validateCompanyRequest = ({
    values,
    intl,
    isInternalForm,
    fromSubmit,
    hasContactError,
    hasPartnerError,
}) => {
    // if (fromSubmit) {
    if (hasContactError) {
        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.CONTACT_INFO_MISSING' }), {
            toastId: 'CONTACT_INFO_MISSING',
            type: 'error',
        });
        return false;
    }

    if (hasPartnerError) {
        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.PARTNER_INFO_MISSING' }), {
            toastId: 'CONTACT_INFO_MISSING',
            type: 'error',
        });
        return false;
    }
    // }

    if (values.contatos.length > 0) {
        let hasPrincipalContact = false;

        values.contatos.forEach((contact) => {
            if (contact.boPrincipalContato) hasPrincipalContact = true;
        });

        if (!hasPrincipalContact) {
            notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.PRINCIPAL_CONTACT_MISSING' }), {
                toastId: 'PRINCIPAL_CONTACT_MISSING',
                type: 'error',
            });
            return false;
        }
    }

    const docsExtrasValidation = validateDocumentsDescription(values.documentos);
    if (!docsExtrasValidation && !isInternalForm) {
        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED' }), {
            toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED',
            type: 'error',
        });
        return false;
    }

    return true;
};

export const validaInclusaoVeiculoComplementar = async (
    intl,
    company,
    cdServico,
    cdSolicitacao,
    vehicles,
    currentIndex,
    subSystems,
    values,
) => {
    const isEmpresaPessoaComplementar =
        company?.tipoEmpresa?.boComplementar ?? company?.tipoPessoaFisica?.boComplementar;
    const isServicoInclusao =
        cdServico === SERVICES_CODES.INCLUSAO_VEICULOS || cdServico === SERVICES_CODES.INCLUSAO_VEICULOS_SEM_CRC;
    const isVeiculoComplementar = subSystems.find(
        (s) => String(s.cdSubSistema) === String(values.cdSubSistema),
    )?.boComplementar;

    if (!isEmpresaPessoaComplementar || !isServicoInclusao || !isVeiculoComplementar) return true;

    if (possuiMaisDeUmVeiculoComplementarListado(subSystems, vehicles, currentIndex, values)) {
        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MAIS_DE_UM_VEICULO_COMPLEMENTAR_LISTADO' }), {
            toastId: 'MESSAGES.SERVICE.FORMS.MAIS_DE_UM_VEICULO_COMPLEMENTAR_LISTADO',
            type: 'error',
        });
        return false;
    }

    const params = Number(cdSolicitacao) ? { params: { cdSolicitacao } } : {};
    const response = await companyEndpoints.buscaSolicitacaoInclusaoVeiculoComplementar(company.cdEmpresa, params);
    if (response && response.status === 200 && !!response.data) {
        notification(
            intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.INCLUSION_ALREADY_REQUESTED' }, { data: response.data }),
            { toastId: 'MESSAGES.SERVICE.FORMS.INCLUSION_ALREADY_REQUESTED', type: 'error' },
        );
        return false;
    }

    return true;
};

const possuiMaisDeUmVeiculoComplementarListado = (subSystems, vehicles, currentIndex = null, values) => {
    const subSistemasComplementares = subSystems.filter((s) => !!s.boComplementar);
    const currentVehicles = vehicles.map((vehicle, index) => (index === currentIndex ? values : vehicle));
    if (currentIndex === null) currentVehicles.push(values);
    const veiculosComplementares = currentVehicles.filter((v) =>
        subSistemasComplementares.find((s) => String(s.cdSubSistema) === String(v.cdSubSistema)),
    );
    return veiculosComplementares.length > 1;
};

export const validateEmailChange = ({ values, intl, isInternalForm }) => {
    const docsExtrasValidation = validateDocumentsDescription(values.documentos);
    if (!docsExtrasValidation && !isInternalForm) {
        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED' }), {
            toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED',
            type: 'error',
        });
        return false;
    }

    return true;
};
